export const NAVIGATION_HEIGHT = 100;
